import { addHours, differenceInHours } from "date-fns";

export const TEAM_MEMBER_DATA_SYNC_MIN_HOURS = 1;

export const canSyncTeamMemberData = (lastSyncedAt: Date | string | null, now = new Date()): boolean => {
  if (lastSyncedAt === null) {
    return true;
  }

  const lastSyncedAtDate = typeof lastSyncedAt === "string" ? new Date(lastSyncedAt) : lastSyncedAt;
  return differenceInHours(now, lastSyncedAtDate) >= TEAM_MEMBER_DATA_SYNC_MIN_HOURS;
};

export const getNextTeamMemberDataSyncDate = (lastSyncedAt: Date | string): Date =>
  addHours(typeof lastSyncedAt === "string" ? new Date(lastSyncedAt) : lastSyncedAt, TEAM_MEMBER_DATA_SYNC_MIN_HOURS);
